import {
  createShapeId,
  pointInPolygon,
  StateNode,
  TLPointerEventInfo,
  TLShapeId,
  TLUnknownShape,
  Vec,
} from "tldraw"
import { CustomDrawShape } from "../../shared/CustomDrawShape"
import { calculateArea } from "./BucketFill"

export class BucketIdle extends StateNode {
  static override id = "idle"
  override onEnter() {
    this.editor.setCursor({ type: "default", rotation: 0 })
  }
  shape: TLShapeId | null = null

  info = {} as TLPointerEventInfo

  isPen = false
  isPenOrStylus = false

  markId = null as null | string
  override onPointerDown(info: TLPointerEventInfo): void {
    this.info = info
    this.parent.transition("bucket-fill", info)
  }

  override onPointerMove(info: TLPointerEventInfo): void {
    this.info = info

    const scaledPoint = this.editor.screenToPage(this.info.point)
    const shapesInside: TLUnknownShape[] = []

    this.editor
      .getPageShapeIds(this.editor.getCurrentPageId())
      .forEach((id) => {
        const shape = this.editor.getShape(id)
        if (shape && shape.type === "custom-draw") {
          const shapeUtil = this.editor.getShapeUtil(shape)
          const shapeGeometry = shapeUtil.getGeometry(shape)

          // Convert the point to the shape's local coordinate space

          const scaledPoint2 = new Vec(scaledPoint.x, scaledPoint.y)

          const localPoint = scaledPoint2.sub({ x: shape.x, y: shape.y })

          if (pointInPolygon(localPoint, shapeGeometry.vertices)) {
            //console.log('area', calculateArea(shapeGeometry.bounds))
            shapesInside.push(shape)
          }
        }
      })
    if (shapesInside.length === 0) {
      this.editor.setCursor({ type: "default", rotation: 0 })
      this.editor.setHoveredShape(null)
      this.shape = null

      return
    }
    const finalShape = shapesInside.sort((shape1: any, shape2: any) => {
      const shapeUtil1 = this.editor.getShapeUtil(shape1)
      const shapeUtil2 = this.editor.getShapeUtil(shape2)
      return (
        calculateArea(shapeUtil1.getGeometry(shape1).bounds) -
        calculateArea(shapeUtil2.getGeometry(shape2).bounds)
      )
    })[0] as CustomDrawShape

    this.editor.setHoveredShape(finalShape.id)

    this.shape = finalShape.id
    this.editor.setCursor({ type: "cross", rotation: 0 })
  }
}
